interface Props { active?: boolean }
export function PlanIcon({ active }: Props) {
  const sw = active ? 2.4 : 1.7;
  return (
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none">
      <circle cx={13} cy={13} r={10} stroke="currentColor" strokeWidth={sw} />
      <circle cx={13} cy={13} r={5} stroke="currentColor" strokeWidth={sw} />
      <circle cx={13} cy={13} r={1.6} fill="currentColor" />
    </svg>
  );
}
